import React, {useState} from 'react';
import {PicturesSubStep} from './PicturesSubStep';
import {PageCountSubStep} from './PageCountSubStep';
import {useUiState} from '../../../Context/UserInterface/UserInterfaceContext';
import {useExperience} from '../../../Experience/ExperienceProvider';
import {AssistantType} from '@taopix/taopix-core';

type SubStepProps = {
  open: boolean;
  onClose: () => void;
  onLastStep: () => void;
};

export type SubStepOptionProps = {
  children?: any;
  isFirstStep: boolean;
  open: boolean;
  height: number;
  width: number;
  onContinue: () => void;
  onClose: () => void;
  onAfterClose: () => void;
  onBack: () => void;
};

export const SubStep = ({open, onLastStep, ...props}: SubStepProps) => {
  const {experience} = useExperience();
  const ui = useUiState();
  const [step, setStep] = useState(0);

  /**
   * Action to execute to continue.
   */
  const onContinue = (): void => {
    const newStep = step + 1;

    if (newStep > steps.length - 1) {
      setStep(0);
      onLastStep();
    } else {
      setStep(newStep);
    }
  };

  /**
   * Action to execute to go back.
   */
  const onBack = (): void => {
    const newStep = Math.max(0, step - 1);
    setStep(newStep);
  };

  /**
   * Action to execute when the substep closes.
   */
  const onClose = (): void => {
    setStep(0);
    props.onClose();
  };

  /**
   * Action to execute after the substep closes.
   */
  const onAfterClose = (): void => {};

  const height = ui.state.isSmallScreen ? 660 : 350;
  const width = ui.state.isSmallScreen ? 400 : 660;

  const steps = [
    AssistantType.SmartDesign === experience.WIZARD.designAssistantType.designAssistantType &&
    'ccc' === experience.WIZARD.picSelectionModeStep.defaultMode ? (
      <PicturesSubStep
        open={open}
        height={height}
        width={width}
        isFirstStep={0 === step}
        onClose={onClose}
        onAfterClose={onAfterClose}
        onBack={onBack}
        onContinue={onContinue}
      />
    ) : null,
    AssistantType.SmartDesign === experience.WIZARD.designAssistantType.designAssistantType &&
    ['ccc'].includes(experience.WIZARD.pageCountModeStep.defaultMode) ? (
      <PageCountSubStep
        open={open}
        height={height}
        width={width}
        isFirstStep={0 === step}
        onClose={onClose}
        onAfterClose={onAfterClose}
        onBack={onBack}
        onContinue={onContinue}
      />
    ) : null,
  ].filter(step => null !== step);

  if (0 === steps.length && open) {
    // Hack to prevent an error about setting state during a render
    // when there are no steps available.
    setTimeout(() => {
      onLastStep();
    }, 1);
    return <></>;
  }

  if (!open) return <></>;
  return <>{steps[step]}</>;
};
